module.exports = __webpack_public_path__ + "static/coin-notes-a41dbca2e3e7c849b3017a4e515cbee6.png";